<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/skill/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jinengbianhao')">
            <el-input v-model="yt.conditions.skillNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jinengmingcheng')">
            <el-input v-model="yt.conditions.skillName"></el-input>
          </el-form-item>
          <!-- 技能分类(数据来源: 客户字典中code="HR_SKILL_TYPE"的所有字典值) -->
          <el-form-item :label="$t('jinengfenlei')">
            <yi_dictionary_select :type="'HR_SKILL_TYPE'" :ids.sync="yt.conditions.skillType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, '680px');
            setDefaultValue();
          "
          type="primary"
          v-if="utils.checkPower('web_employment_management_skill_add_button')"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" plain @click="importShow = !importShow" v-if="utils.checkPower('web_employment_management_skill_batchImport')">
          {{ $t('daoru') }}
        </el-button>
        <el-popconfirm title="是否确认批量删除?" confirm-button-text="是" cancelButtonText="否" @confirm="batchDelete()" v-if="utils.checkPower('web_employment_management_skill_batchDelete')">
          <el-button size="mini" type="primary" :disabled="batchDeletDisabled" slot="reference" style="margin-left: 10px" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '技能管理-批量删除' } }">{{ $t('piliangshanchu') }}</el-button>
        </el-popconfirm>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="yt.exportExcel(`用工管理_技能管理_导出_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}`)"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_skill_update_button')">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, '680px')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_skill_delete_button')">
            <el-popconfirm title="是否确认删除技能？删除后可能造成基础数据缺失" confirm-button-text="是" cancelButtonText="否" @confirm="deleteRecord(scope.row)">
              <el-button type="text" class="font-color-danger" slot="reference" :loading="loading">{{ $t('shanchu') }}</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" :before-close="close">
      <!-- 新增或编辑 -->
      <template v-if="yt.editObj.action == 'xinzeng' || yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <div>
            <el-form-item :label="$t('jinengbianhao')" required>
              <el-input v-model="yt.editObj.skillNo"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="$t('jinengmingcheng')" required>
              <el-input v-model="yt.editObj.skillName"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="$t('jinengfenlei')" required>
              <yi_dictionary_select :type="'HR_SKILL_TYPE'" :ids.sync="yt.editObj.skillType"> </yi_dictionary_select>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="$t('suoshuzuzhi')" required>
              <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="$t('yaoqiupeixun')" required>
              <el-radio-group v-model="yt.editObj.needTraining">
                <el-radio :label="true">{{ $t('shi') }}</el-radio>
                <el-radio :label="false">{{ $t('fou') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item :label="$t('yaoqiukaoshi')" required>
              <el-radio-group v-model="yt.editObj.needExam" @change="needExamChange">
                <el-radio :label="true">{{ $t('shi') }}</el-radio>
                <el-radio :label="false">{{ $t('fou') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="_passMark">
              <el-form-item :label="$t('jigefenshu')" required>
                <el-input :disabled="passingMarkDisabled" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.passingMark"></el-input>
                <!-- <yi_number_input :max="100" :min="0" :start.sync="yt.editObj.passingMark"></yi_number_input> -->
              </el-form-item>
            </div>
          </div>
          <div>
            <el-form-item :label="$t('yaoqiushicao')" required>
              <el-radio-group v-model="yt.editObj.needPractice">
                <el-radio :label="true">{{ $t('shi') }}</el-radio>
                <el-radio :label="false">{{ $t('fou') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="normal">
            <el-form-item :label="$t('morenqixian(yue)')" required>
              <!-- <el-input oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.defaultAuthDay"></el-input> -->
              <yi_number_input :max="1200" :min="0" :start.sync="yt.editObj.defaultAuthDay"></yi_number_input>
              <i style="color:red;">{{ this.rangeStr }}</i>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" size="mini" :loading="yt.editObj.loading" @click="create" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" size="mini" :loading="yt.editObj.loading" @click="update" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导入 -->
    <import_excel :show.sync="importShow" />
  </div>
</template>

<script>
import Yi_number_input from '@/common/yi_number_input/yi_number_input.vue';
import import_excel from './import_excel.vue';
import { utils } from 'xlsx';

export default {
  name: 'web_employment_management_skill_list',
  components: {
    import_excel
  },
  data() {
    return {
      rangeStr: '',
      loading: false,
      skillType: [],
      passingMarkDisabled: true,
      importShow: false,
      selected: [],
      batchDeletDisabled: true,
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          selectable: (row, index) => {
            return true;
          },
          width: 30
        },
        {
          label: 'jinengbianhao',
          prop: 'skillNo'
        },
        {
          label: 'jinengmingcheng',
          prop: 'skillName'
        },
        {
          label: 'jinengfenlei',
          prop: 'skillType',
          type: 'dictionary',
          key: 'HR_SKILL_TYPE'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name'
        },
        {
          label: 'yaoqiupeixun',
          prop: 'needTraining',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'yaoqiukaoshi',
          prop: 'needExam',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'yaoqiushicao',
          prop: 'needPractice',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'morenqixian(yue)',
          prop: 'defaultAuthDay'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        }
      ]
    };
  },
  destroyed() {
    this.utils.event_hub.$off('EMPLOYMENT_MANAGEMENT_SKILL_REFRESH');
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.getSkillType();

      this.utils.event_hub.$on('EMPLOYMENT_MANAGEMENT_SKILL_REFRESH', () => {
        this.yt.get();
      });
    }, 300);
  },
  watch: {
    'yt.editObj': {
      handler(newVal) {
        if (newVal.defaultAuthDay !== undefined) {
          this.range(newVal.defaultAuthDay);
        }
      },
      deep: true // 必须加 deep，否则子属性变化不会触发
    }
  },
  methods: {
    batchDelete() {
      if (this.selectIds.length === 0) {
        this.$message({
          message: this.$t('qinggouxuanshuju'),
          type: 'error'
        });
        return;
      }
      this.http
        .post('web/skill/batchDelete', this.selectIds)
        .then(res => {
          this.$message({
            message: this.$t('success'),
            type: 'success'
          });
          this.selectIds = [];
          this.yt.get();
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    selectionChange(items) {
      this.selectIds = items.map(item => {
        return item.id;
      });
      if (this.selectIds.length > 0) {
        this.batchDeletDisabled = false;
      } else {
        this.batchDeletDisabled = true;
      }
    },
    range(num) {
      if (num === 0 || num === undefined || num === null) {
        this.rangeStr = '';
        return;
      }
      // 计算时间范围
      let start = new Date();
      let end = new Date();
      end.setMonth(start.getMonth() + num);
      if (num >= 1200) {
        //rangeStr = '永久';
        this.rangeStr = this.$t('yongjiu');
      } else {
        this.rangeStr = '';
        // this.rangeStr = this.$t('youxiaoqizhi') + start.toLocaleDateString() + ' - ' + end.toLocaleDateString();
      }
    },
    getSkillType() {
      this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', { params: { code: 'HR_SKILL_TYPE' } }).then(res => {
        this.skillType = res.data;
        if (this.skillType.length < 1) {
          this.$message.error(this.$t('qingxianweihushujuzidian') + ':' + this.$t('jinengfenlei'));
        }
      });
    },
    deleteRecord(data) {
      this.loading = true;
      this.http
        .post('web/skill/delete', data)
        .then(res => {
          this.$message({
            message: this.$t('success'),
            type: 'success'
          });
          this.yt.get();
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    needExamChange() {
      this.passingMarkDisabled = !this.yt.editObj.needExam;
      if (!this.yt.editObj.needExam) {
        this.yt.editObj.passingMark = 0;
      }
    },
    setDefaultValue() {
      if (this.yt.editObj.needTraining == null || this.yt.editObj.needTraining == undefined) {
        this.$set(this.yt.editObj, 'needTraining', false);
      }
      if (this.yt.editObj.needExam == null || this.yt.editObj.needExam == undefined) {
        this.$set(this.yt.editObj, 'needExam', false);
      }
      if (this.yt.editObj.needPractice == null || this.yt.editObj.needPractice == undefined) {
        this.$set(this.yt.editObj, 'needPractice', false);
      }
    },
    create() {
      if (this.validate()) {
        this.yt.req('POST', '/web/skill/create');
      }
    },
    update() {
      if (this.validate()) {
        this.yt.req('POST', '/web/skill/update');
      }
    },
    validate() {
      if (this.yt.editObj.needExam == true) {
        if (this.yt.editObj.passingMark === undefined || this.yt.editObj.passingMark === null || this.yt.editObj.passingMark === '') {
          this.$message.error(this.$t('jigefenshu') + this.$t('bunengweikong'));
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    close() {
      this.passingMarkDisabled = true;
      this.yt.isShowEditDialog = false;
    }
  }
};
</script>

<style scoped lang="scss">
._passMark {
  width: 360px;
  display: flex;
}

._passMark /deep/ .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  width: 80px;
  padding: 0 10px 0 0;
  box-sizing: border-box;
}

._passMark /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-image: none;
  border-radius: 4px;
  box-sizing: border-box;
  display: inline-block;
  font-size: 14px;
  outline: none;
  padding: 0 10px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 80px;
  line-height: 25px;
  height: 25px;
}

.normal /deep/ form .el-date-editor,
form .el-input,
form .el-select,
form .el-textarea {
  width: 195px;
  min-width: 10px;
}
</style>
